module.exports = __webpack_public_path__ + "static/media/sm.8f697f6c.jpeg";